import React, { useState } from 'react';

const DISMISSED_KEY = 'zenith_telegram_email_dismissed';

function TelegramEmailPrompt({ onLinkEmail, onDismiss }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    setError(null);
    try {
      await onLinkEmail(email);
      setSuccess('Email linked successfully! You can now sign in with this email.');
    } catch (err) {
      setError(err.message || 'Failed to link email');
    } finally {
      setLoading(false);
    }
  };

  const handleSkip = () => {
    localStorage.setItem(DISMISSED_KEY, 'true');
    onDismiss();
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.icon}>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2" y="4" width="20" height="16" rx="2" />
            <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
          </svg>
        </div>

        <h2 style={styles.title}>Add Your Email</h2>
        <p style={styles.description}>
          Secure your account by adding an email address. This lets you sign in with email, connect Google, and recover your account.
        </p>

        {success ? (
          <div style={styles.successBox}>
            {success}
            <button onClick={handleSkip} style={styles.doneButton}>Done</button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={styles.form}>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              style={styles.input}
              required
              disabled={loading}
            />

            {error && <div style={styles.error}>{error}</div>}

            <button
              type="submit"
              disabled={loading || !email}
              style={{
                ...styles.submitButton,
                opacity: (loading || !email) ? 0.5 : 1,
                cursor: (loading || !email) ? 'not-allowed' : 'pointer',
              }}
            >
              {loading ? 'Linking...' : 'Link Email'}
            </button>

            <button
              type="button"
              onClick={handleSkip}
              style={styles.skipButton}
            >
              Skip for now
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

TelegramEmailPrompt.isDismissed = () => {
  return localStorage.getItem(DISMISSED_KEY) === 'true';
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    padding: '20px',
  },
  modal: {
    backgroundColor: 'white',
    borderRadius: '16px',
    padding: '32px',
    maxWidth: '420px',
    width: '100%',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.2)',
    textAlign: 'center',
  },
  icon: {
    marginBottom: '16px',
  },
  title: {
    fontSize: '20px',
    fontWeight: '700',
    color: '#1f2937',
    margin: '0 0 8px',
  },
  description: {
    fontSize: '14px',
    color: '#6b7280',
    lineHeight: '1.5',
    margin: '0 0 24px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  input: {
    padding: '12px 14px',
    fontSize: '16px',
    border: '1px solid #d1d5db',
    borderRadius: '8px',
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box',
  },
  submitButton: {
    padding: '12px',
    fontSize: '16px',
    fontWeight: '600',
    backgroundColor: '#3b82f6',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
  },
  skipButton: {
    padding: '8px',
    fontSize: '14px',
    color: '#6b7280',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  error: {
    padding: '10px',
    borderRadius: '8px',
    backgroundColor: '#fee2e2',
    color: '#991b1b',
    fontSize: '13px',
  },
  successBox: {
    padding: '16px',
    borderRadius: '8px',
    backgroundColor: '#d1fae5',
    color: '#065f46',
    fontSize: '14px',
  },
  doneButton: {
    marginTop: '12px',
    padding: '10px 24px',
    fontSize: '14px',
    fontWeight: '600',
    backgroundColor: '#10b981',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    display: 'block',
    width: '100%',
  },
};

export default TelegramEmailPrompt;
